import Cookies from 'js-cookie';
import $ from 'jquery';
const hideCookieTimeLength = 30 * 24 * 60 * 60 * 1000; //30 days

class CookieConsent {
    constructor() {
        if (!Cookies.get('cookie-consent-given')) {
            this.body = $('body');
            this.initialize();
        }
    }
    confirm() {
        Cookies.set('cookie-consent-given', true, {
            expires: new Date(new Date().getTime() + hideCookieTimeLength)
        });
        this.close();
    }
    initialize() {
        this.render();
        this.open();
    }
    render() {
        const template =
            `<div class="cookie-consent">
                <div class="cookie-consent__message">This site uses cookies to monitor site usage and web traffic, assist with promotional and marketing efforts, and to offer you a more personalized experience.  By continuing to use this website, you consent to their use.</div>
                <div class="cookie-consent__dismiss button">Continue</div>
            </div>`;
        this.el = $(template);
        this.body.append(this.el);
        this.el.find('.cookie-consent__dismiss').click(this.confirm.bind(this));
    }
    open() {
        setTimeout(() => {
            this.el.addClass('cookie-consent--display');
        },
        200);
    }
    close() {
        this.el.removeClass('cookie-consent--display');
    }


}

export default CookieConsent;